<template>
  <v-container fluid v-if="user">
    <v-container>
      <v-card>
        <v-card-title class="text-center teal lighten-3 accent-4 white--text">
          Kardex
        </v-card-title>
        <v-row class="mx-2 mt-1">
          <v-col cols="6" md="3">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fechaInicial"
                  label="Fecha inicial"
                  prepend-icon="mdi-calendar"
                  readonly
                  required
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fechaInicial"
                no-title
                color="teal lighten-3"
                locale="es-MX"
                @input="menu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6" md="3">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fechaFin"
                  label="Fecha fin"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fechaFin"
                no-title
                color="teal lighten-3"
                locale="es-MX"
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" lg="3" md="3">
            <v-select
              v-model="sucursalSelected"
              :items="sucursales"
              :item-value="(item) => item"
              label="Sucursal"
              placeholder="Selecciona sucursal"
              @change="codigo_almacen = sucursalSelected.codigo_almacen"
            ></v-select>
          </v-col>
          <v-col cols="12" lg="3" md="3">
            <v-text-field
              label="Código almacén"
              v-model="codigo_almacen"
              clearable
            />
          </v-col>
          <v-col cols="12" lg="3" md="3">
            <v-autocomplete
              v-model="codigo_producto"
              :items="productos"
              item-text="codigo"
              item-value="codigo"
              label="Buscar producto"
              hide-no-data
              hide-overlay
              prepend-icon="mdi-barcode"
              placeholder="Selecciona producto"
              :searchable="true"
              clearable
              :loading="loading"
              @update:search-input="onUpdateSearch"
              :filter="TextoProducto"
            >
              <template #item="{ item }">
                <div>
                  <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                  <v-list-item-subtitle>{{ item.codigo }}</v-list-item-subtitle>
                </div>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="2">
            <v-btn @click="getKardex" small class="mt-5">Buscar</v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <!-- Mostrar una tarjeta por cada consulta -->
    <v-row class="mt-3">
      <v-col cols="12" md="8" class="mx-auto">
        <v-text-field
          v-if="consultasKardex.length > 0"
          v-model="busqueda"
          label="Filtro de búsqueda"
          prepend-icon="mdi-magnify"
          clearable
          class="mt-2"
        >
        </v-text-field>
      </v-col>
      <v-col
        v-for="(consulta, index) in consultasKardex"
        :key="index"
        cols="12"
        sm="6"
        md="6"
      >
        <v-card>
          <v-card-title class="d-flex justify-space-between align-center">
            <v-icon
              color="red"
              @click="eliminarConsulta(index)"
              class="ml-2 icon-close"
              title="Eliminar"
              >mdi-close</v-icon
            >
            <strong class="sucursal-texto">{{ consulta.sucursal }}</strong>
            <div>
              {{ consulta.codigo_producto }} {{ consulta.nombre_producto }}
              <br />
              de
              {{ consulta.fechaInicial }} a
              {{ consulta.fechaFin }}
            </div>
          </v-card-title>
          <div style="max-height: 400px; overflow-y: auto">
            <v-data-table
              :headers="headers"
              :items="filtrarItems(consulta.lista)"
              :loading="loading"
              :items-per-page="-1"
              dense
              fixed-header
              class="elevation-1"
              no-data-text="No hay resultados para mostrar"
            />
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      menu: false,
      menu2: false,
      fechaInicial: moment().startOf("month").format("YYYY-MM-DD"),
      fechaFin: moment().format("YYYY-MM-DD"),
      codigo_almacen: "",
      codigo_producto: "",
      productos: [],
      allProductos: [],
      loading: false,
      listaKardex: [],
      consultasKardex: [], // Arreglo para almacenar las consultas
      sucursalSelected: [],
      busqueda: "",
      sucursales: [
        {
          text: "Mexicali",
          value: "Mexicali",
          codigo_almacen: "101",
        },
        {
          text: "Tijuana",
          value: "Tijuana",
          codigo_almacen: "11",
        },
        {
          text: "Ensenada",
          value: "Ensenada",
          codigo_almacen: "18",
        },
        {
          text: "La Paz",
          value: "LaPaz",
          codigo_almacen: "23",
        },
        {
          text: "Obregon",
          value: "Obregon",
          codigo_almacen: "16",
        },
        {
          text: "Hermosillo",
          value: "Hermosillo",
          codigo_almacen: "13",
        },
      ],
      headers: [
        {
          text: "Fecha",
          value: "fecha",
        },
        {
          text: "Concepto",
          value: "concepto",
        },
        {
          text: "Serie y folio",
          value: "serie_folio",
        },
        {
          text: "Cantidad",
          value: "cantidad_neta",
        },
        {
          text: "Existencia",
          value: "acumulado",
        },
      ],
    };
  },
  methods: {
    filtrarItems(items) {
      if (!this.busqueda) return items;
      return items.filter((item) => {
        return (
          item.fecha.toLowerCase().includes(this.busqueda.toLowerCase()) ||
          item.concepto.toLowerCase().includes(this.busqueda.toLowerCase()) ||
          item.serie_folio
            .toLowerCase()
            .includes(this.busqueda.toLowerCase()) ||
          item.cantidad_neta.toString().includes(this.busqueda.toLowerCase()) ||
          item.acumulado.toString().includes(this.busqueda.toLowerCase())
        );
      });
    },

    eliminarConsulta(index) {
      this.consultasKardex.splice(index, 1);
    },

    async getKardex() {
      if (
        !this.fechaInicial ||
        !this.fechaFin ||
        !this.codigo_producto ||
        !this.sucursalSelected ||
        !this.codigo_almacen
      ) {
        alert("Por favor completa todos los campos requeridos.");
        return;
      }

      this.loading = true;
      try {
        const response = await axios.get(
          `/reportes/kardex?fecha_inicial=${this.fechaInicial}&fecha_final=${this.fechaFin}&sucursal=${this.sucursalSelected.value}&codigo_almacen=${this.codigo_almacen}&codigo_producto=${this.codigo_producto}`
        );
        const responseData = response.data.movimientos;

        if (responseData && responseData.data && responseData.index) {
          this.listaKardex = responseData.index.map((idx, i) => {
            return {
              index: idx,
              fecha: responseData.data[i][4]?.split("T")[0] || "",
              concepto: responseData.data[i][3],
              serie_folio: `${responseData.data[i][1]} - ${responseData.data[i][2]}`,
              cantidad_neta: parseFloat(responseData.data[i][16]).toFixed(2),
              acumulado: parseFloat(responseData.data[i][17]).toFixed(2),
            };
          });

          this.consultasKardex.push({
            codigo_producto: this.codigo_producto,
            nombre_producto:
              (
                this.productos.find(
                  (item) => item.codigo === this.codigo_producto
                ) || {}
              ).nombre || "",
            sucursal: this.sucursalSelected.text,
            fechaInicial: this.fechaInicial,
            fechaFin: this.fechaFin,
            lista: this.listaKardex,
          });
        }
        //console.log("Kardex data:", this.listaKardex);
      } catch (error) {
        console.error("Error al obtener el kardex:", error);
      } finally {
        this.loading = false;
      }
    },

    async getProductos() {
      this.loading = true;
      try {
        const response = await axios.get(`/productos/get_lista`);
        const data = response.data;
        this.allProductos = (data || []).map((item) => ({
          codigo: item[0],
          nombre: item[1],
        }));
        this.productos = this.allProductos;
      } catch (error) {
        console.error("Error fetching productos:", error);
      } finally {
        this.loading = false;
      }
    },

    onUpdateSearch(search) {
      if (!search) {
        this.productos = this.allProductos;
      } else {
        this.productos = this.allProductos.filter((item) => {
          return (
            item.nombre.toLowerCase().includes(search.toLowerCase()) ||
            item.codigo.toLowerCase().includes(search.toLowerCase())
          );
        });
      }
    },
    TextoProducto(item) {
      return `${item.nombre} (${item.codigo})`;
    },
  },
  mounted() {
    this.getProductos();
  },
  watch: {},
  created() {},
  components: {},
  computed: {
    ...mapGetters(["user"]),
  },
};
</script>
<style scoped>
.icon-close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
.sucursal-texto {
  display: block;
  width: 100%;
  text-align: center;
  margin-bottom: 6px;
  font-size: 1.65rem;
}
</style>
